// src/hooks/countries/useDeleteAllCountries.js
import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { deleteAllCountries } from "../../api/apiCountries";
import parseError from "../../utils/parseError";

const useDeleteAllCountries = () => {
    const queryClient = useQueryClient();

    const {
        mutate: deleteAll,
        isPending: isDeletingAll,
    } = useMutation({
        mutationFn: deleteAllCountries,
        onSuccess: (res) => {
            const message = res?.message || "Selected countries deleted successfully";
            toast.success(message);
            queryClient.invalidateQueries({ queryKey: ["countries"] });
        },
        onError: (error) => {
            const msg = parseError(error);
            toast.error(msg || "Failed to delete selected countries");
        },
    });

    return {
        deleteAllCountries: deleteAll,
        isDeleteAll: isDeletingAll,
    };
};

export default useDeleteAllCountries;
